import api from '@/api'
import { API_ENDPOINTS, OAUTH_PROVIDERS } from '@/constants'
import logger from '@/utils/logger'

/**
 * Initiate OAuth flow by redirecting to backend OAuth endpoint
 * @param {string} provider - OAuth provider ('google', 'microsoft', 'facebook')
 */
export function initiateOAuth(provider) {
  if (!Object.values(OAUTH_PROVIDERS).includes(provider)) {
    logger.error('Invalid OAuth provider', { provider })
    throw new Error(`Unsupported OAuth provider: ${provider}`)
  }

  try {
    // Redirect to backend OAuth authorize endpoint
    // The backend will redirect to the OAuth provider
    const authorizeUrl = `${api.defaults.baseURL}${API_ENDPOINTS.OAUTH_AUTHORIZE(provider)}`
    window.location.href = authorizeUrl
  } catch (error) {
    logger.error('Failed to initiate OAuth', { provider, error: error.message })
    throw error
  }
}

/**
 * Handle OAuth callback by extracting token from URL
 * @returns {string|null} - Access token or null if not found
 */
export function handleOAuthCallback() {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const provider = urlParams.get('provider')

    if (token) {
      // Clean up URL by removing token from query params
      const cleanUrl = window.location.pathname
      window.history.replaceState({}, document.title, cleanUrl)
      
      logger.info('OAuth callback successful', { provider })
      return { token, provider }
    }

    return null
  } catch (error) {
    logger.error('Failed to handle OAuth callback', { error: error.message })
    return null
  }
}



